import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton,
    Drawer,
    useTheme,
    useMediaQuery
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { CloseRounded } from "@mui/icons-material";
import { CircleLoader, BounceLoader, ClipLoader } from 'react-spinners'


const EditSpaceDetailsPopup = ({ open, onClose, data = {}, width = 420, onComplete = () => { } }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [spaceName, setSpaceName] = useState("")
    const [spaceDescription, setSpaceDescription] = useState("")
    const [spaceSupportMail, setSpaceSupportMail] = useState("")
    const [spaceType, setSpaceType] = useState("")
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (open) {
            setSpaceName(data.name ?? "")
            setSpaceDescription(data.description ?? "")
            setSpaceSupportMail(data.supportMail ?? "")
            setSpaceType(data.type ?? "")
        }
    }, [open])


    const createSpace = async () => {
        // setloading(true);
        setLoading(true)
        const token = localStorage.getItem("token");

        const body = JSON.stringify({
            name: spaceName,
            description: spaceDescription,
            mail: spaceSupportMail,
            type: spaceType,
            spaceId: data._id ? data._id : null
        })
        const response = await fetch(`${BASE_URL}/spaces/update-spcs`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: body
        });
        const json = await response.json();
        if (json.success === true) {
            onComplete()
        } else {
            alert(json.response)
        }
        setLoading(false)

    };



    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 420,
                    height: isMobile ? "85vh" : "100vh",
                    borderRadius: isMobile ? "20px 20px 0 0" : 0,
                    background: "#0f0e0fff",
                    flexDirection: 'column',
                    display: 'flex'
                }
            }}
        >



            {/* Body */}
            <Box sx={styles.body}>
                <Box sx={styles.header}>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                    <span style={styles.title}>{"Update space details"}</span>

                </Box>

                <Typography style={{
                    fontSize: "12px",
                    fontFamily: "poppins-reg", color: "#ffffff",
                    marginInline: "18px", marginTop: "20px", marginBottom: "4px"
                }}>{"Space name"}</Typography>
                <Box sx={{
                    flexDirection: 'row',
                    backgroundColor: "#ffffff10",
                    display: 'flex',
                    borderRadius: "10px",
                    marginInline: "15px",
                    border: "1px solid #aaaaaa30",
                    background: "#000000"
                }}>

                    <input placeholder="Enter a space name..."
                        multiple={false}
                        value={spaceName}
                        onChange={(v) => {
                            setSpaceName(v.target.value)
                        }}
                        style={{
                            outline: 'none',
                            backgroundColor: "#aaaaaa00",
                            borderWidth: 0,
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            paddingTop: "12px",
                            flex: 1,
                            display: 'flex',
                            fontSize: "14px",
                            paddingBottom: "12px",
                            fontFamily: 'poppins-reg',
                            color: "white"
                        }} />


                </Box>

                <Typography style={{
                    fontSize: "12px",
                    fontFamily: "poppins-reg", color: "#ffffff",
                    marginInline: "18px", marginTop: "10px", marginBottom: "4px"
                }}>{"Space Description"}</Typography>
                <Box sx={{
                    flexDirection: 'row',
                    backgroundColor: "#ffffff10",
                    display: 'flex',
                    marginInline: "15px",
                    borderRadius: "10px",
                    border: "1px solid #aaaaaa30",
                    background: "#000000"
                }}>

                    <textarea placeholder="Enter space description..."
                        rows={5}
                        value={spaceDescription}

                        onChange={(v) => {
                            setSpaceDescription(v.target.value)
                        }}
                        style={{
                            outline: 'none',
                            backgroundColor: "#aaaaaa00",
                            borderWidth: 0,
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            paddingTop: "12px",
                            flex: 1,
                            display: 'flex',
                            fontSize: "14px",
                            paddingBottom: "12px",
                            fontFamily: 'poppins-reg',
                            color: "white"
                        }} />


                </Box>
                <Typography style={{
                    fontSize: "12px",
                    fontFamily: "poppins-reg", color: "#ffffff",
                    marginInline: "18px", marginTop: "10px", marginBottom: "4px"
                }}>{"Support Mail"}</Typography>
                <Box sx={{
                    flexDirection: 'row',
                    backgroundColor: "#ffffff10",
                    display: 'flex',
                    marginInline: "15px",
                    borderRadius: "10px",
                    border: "1px solid #aaaaaa30",
                    background: "#000000"
                }}>

                    <input
                        multiple={false}
                        inputMode={'email'}
                        type={'email'}
                        placeholder="Enter space support mail..."
                        value={spaceSupportMail}

                        onChange={(v) => {
                            setSpaceSupportMail(v.target.value)
                        }}
                        style={{
                            outline: 'none',
                            backgroundColor: "#aaaaaa00",
                            borderWidth: 0,
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            paddingTop: "12px",
                            flex: 1,
                            display: 'flex',
                            fontSize: "14px",
                            paddingBottom: "12px",
                            fontFamily: 'poppins-reg',
                            color: "white"
                        }} />

                </Box>

                <Typography style={{
                    fontSize: "12px",
                    fontFamily: "poppins-reg", color: "#ffffff",
                    marginInline: "18px", marginTop: "10px",
                }}>{"Space Type"}</Typography>

                <FormControl margin="dense" required sx={{ marginInline: "15px", width: "200px" }}>
                    <Select style={{
                        fontFamily: 'poppins-reg', fontSize: "14px",
                    }} sx={{
                        fontFamily: "poppins-reg",
                        fontSize: 14,

                        // HEIGHT / PADDING
                        "& .MuiSelect-select": {
                            padding: "12px 14px",
                            background: "#000000",
                            borderRadius: "10px",
                        },

                        // BORDER COLOR
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#aaaaaa30",
                            borderRadius: "10px",
                        },

                        // HOVER
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#aaaaaa30",
                        },

                        // FOCUSED
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#aaaaaa30",
                            borderWidth: "1px",
                        },

                        // TEXT COLOR
                        color: "#ffffff",
                    }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    bgcolor: "#000000",
                                    color: "#ffffff",
                                }
                            }
                        }} name="Space Type" value={spaceType} onChange={(value) => setSpaceType(value.target.value)} required>
                        {["Campus", "Business"].map((creator) => (
                            <MenuItem key={creator} value={creator}>{creator}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box sx={{ flex: 1, display: 'flex' }} />

                <Box onClick={() => {
                    if (spaceName.length == 0 || spaceDescription.length == 0 || spaceSupportMail.length == 0 || spaceType.length == 0) {
                        alert("Make sure to enter all the required fields.")
                    } else {
                        createSpace()
                    }
                }} sx={{
                    background: "#943bff", borderRadius: "100px", marginInline: "15px", marginBottom: "20px",
                    display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBlock: "13px",
                    userSelect: 'none', cursor: 'pointer'
                }}>
                    {
                        loading ? (
                            <Box sx={{ display: 'flex', alignSelf: 'center', marginBlock: "2px" }}>
                                <ClipLoader size={"18px"} color={"#ffffff"} />
                            </Box>
                        ) : (
                            <Typography sx={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff" }} >Update</Typography>
                        )
                    }

                </Box>

            </Box>
        </Drawer>

    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        px: 1,
        py: 2,
        borderBottom: "1px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        overflowY: "auto",
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    }
};


export default EditSpaceDetailsPopup;
